import { Component, OnChanges, Input, SimpleChanges, NgZone, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { ChannelInteractionRateDevelopment } from '../../../../../models/influencer/channel-interaction-rate-development';
import { UserService } from '../../../../services/user.service';
import { chartConfig } from '../../../../app.constants';

@Component({
    selector: 'interaction-rate-development',
    templateUrl: './interaction-rate-development.component.html',
    styleUrls: ['./interaction-rate-development.component.scss']
})
export class InteractionRateDevelopmentComponent implements OnChanges, AfterViewInit, OnDestroy {
    private readonly _seriesConfig: any;
    public readonly areaFillColor = {
        linearGradient: {
            x1: 0.5,
            y1: 0.4461,
            x2: 0.5,
            y2: 0.9806
        },
        stops: [
            [0, '#EEF2F57F'],
            [1, `#FFFFFF00`]
        ]
    };
    public readonly overridenTooltipConfig = {
        useHTML: false,
        padding: 4,
        borderRadius: 6,
        borderWidth: 6,
        borderColor: chartConfig.tooltipBackgroundColor,
        style: {
            color: chartConfig.lineChart.tooltipColor,
            fontFamily: chartConfig.font.light,
            fontSize: '12px'
        }
    };
    public readonly placeholderData: Array<any>;
    public data: Array<any>;
    public hasNoData = true;
    public axisFontFamily = chartConfig.font.semiBold;

    private _tooltipInterval;

    @Input() channelInteractionRateDevelopments: ChannelInteractionRateDevelopment[];
    @Input() isFetchingData: boolean;

    constructor(userService: UserService, private _hostElRef: ElementRef, private _ngZone: NgZone) {
        const color = userService.chartColors[0];
        this._seriesConfig = {
            type: 'area',
            color: color,
            name: 'Interaction Rate Development',
            lineWidth: 4,
            marker: { symbol: 'circle', fillColor: color, radius: 4, enabled: true }
        };
        this.placeholderData = [
            {
                ...this._seriesConfig,
                data: []
            }
        ];
        this.data = this.placeholderData;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.channelInteractionRateDevelopments) {
            const value = changes.channelInteractionRateDevelopments.currentValue;

            if (!Array.isArray(value) || value.length === 0) {
                this.hasNoData = true;
                this.stopTooltipInterval();
                return;
            }

            this.data = this.convertToChartData(value);
            this.hasNoData = false;
            this.refreshTooltipInterval();
        }
    }

    ngAfterViewInit(): void {
        this.refreshTooltipInterval();
    }

    ngOnDestroy(): void {
        this.stopTooltipInterval();
    }

    private stopTooltipInterval() {
        if (this._tooltipInterval) {
            clearInterval(this._tooltipInterval);
        }
    }

    private refreshTooltipInterval() {
        this.stopTooltipInterval();
        this._ngZone.runOutsideAngular(() => {
            this._tooltipInterval = setInterval(() => {
                const hostEl = this._hostElRef && this._hostElRef.nativeElement;

                if (hostEl) {
                    const textEl = hostEl.querySelector('.highcharts-tooltip > text');

                    if (textEl) {
                        textEl.setAttribute('y', 14);
                        clearInterval(this._tooltipInterval);
                    }
                }
            }, 10);
        });
    }

    private convertToChartData(channelInteractionRateDevelopments: ChannelInteractionRateDevelopment[]): any[] {
        const data = channelInteractionRateDevelopments.map(x => {
            return [this.convertToDateNumber(x.time), x.engagementRate * 100];
        });
        return [{
            ...this._seriesConfig,
            data
        }];
    }

    /**
    * @param {number} monthString: MM-YYYY
    */
    private convertToDateNumber(monthString: string): number {
        const parts = monthString.split('-');
        const year = Number.parseInt(parts[1], 10);
        const month = Number.parseInt(parts[0], 10) - 1;
        const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        return date.getTime();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/interaction-rate-development/interaction-rate-development.component.ts